$(document).ready(function () {
	
	
	var $panels = $('#home-hero #scroll-container .panel');
	var $container = $('#home-hero #scroll-container');

	var horizontal = true;

	if (horizontal) {
		$panels.css({
			'float' : 'left',
			'position' : 'relative', // IE fix to ensure overflow is hidden
			'visibility' : 'visible'
		});
		$container.css('width', $panels[0].offsetWidth * $panels.length);
	}

	var $scroll = $('#home-hero').css('overflow', 'hidden');
	var cycleTimer = setInterval(function (){$scroll.trigger('next')}, 1800);

	function selectNav() {
		$(this)
			.parents('#slideshow-nav')
				.find('li a')
					.removeClass('on')
				.end()
			.end()
			.addClass('on');
	}


	function trigger(data) {
		var el = $('#slideshow-nav').find('a[href$="' + data.id + '"]').get(0);
		selectNav.call(el);
		//$(data).css('display', 'block');
	}
	
	


	var offset = parseInt((horizontal ? 
		$container.css('paddingTop') : 
		$container.css('paddingLeft')) 
		|| 0) * -1;

	var scrollOptions = {
		target: $scroll, 
		items: $panels,
		navigation: '#slideshow-nav li a',
		axis: 'xy',
		onAfter: trigger,
		offset: offset,
		duration: 500,
		easing: 'swing',
		prev: 'img.left', 
		next: 'img.right'
	};

	$('#hero-slideshow').serialScroll(scrollOptions);

	$.localScroll(scrollOptions);

	scrollOptions.duration = 1;
	$.localScroll.hash(scrollOptions);
	
	
});